<template>
  <div class="el-modals-2">
    <vip-dialog></vip-dialog>
    <confirm-again></confirm-again>
    <share></share>
    <custom-works></custom-works>
    <customWorksSubmitted></customWorksSubmitted>
    <setUserCategories></setUserCategories>
    <moveToCategory></moveToCategory>
  </div>
</template>

<script>
/**
 * 会员等级相关弹窗
 */
import { mapGetters } from 'vuex'
import vipDialog from './topnav/vipDialog.vue'
import confirmAgain from './topnav/exportDialog/confirmAgain.vue'
import share from './topnav/exportDialog/share.vue'
import customWorks from './topnav/customWorks.vue'
import customWorksSubmitted from './emodal/customWorksSubmitted.vue'
import setUserCategories from './rightnav/modals/setUserCategories.vue'
import moveToCategory from './rightnav/modals/moveToCategory.vue'

export default {
  components: {
    vipDialog,
    confirmAgain,
    share,
    customWorks,
    customWorksSubmitted,
    setUserCategories,
    moveToCategory
  },
  data () {
    return {
      customWorks: false,
    }
  },
  created () {
    const vm = this;
    this.$bus.on('killCustomWorks', () => {
      vm.customWorks = false;
    });
    this.$bus.on('createCustomWorks', () => {
      vm.customWorks = true;
    });
  },
  computed: {
    ...mapGetters([
      'TopnavMsg',
      'SoundRecord',
    ])
  },
}
</script>

<style lang="scss" scoped>
.el-modals-2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 30;
}
</style>



// WEBPACK FOOTER //
// src/components/EModals2.vue